import { render, staticRenderFns } from "./LockSimpleButton.vue?vue&type=template&id=3e0ba234&scoped=true&"
import script from "./LockSimpleButton.vue?vue&type=script&lang=js&"
export * from "./LockSimpleButton.vue?vue&type=script&lang=js&"
import style0 from "./LockSimpleButton.vue?vue&type=style&index=0&id=3e0ba234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0ba234",
  null
  
)

export default component.exports